import { Map } from "immutable";

import postsActions from "./actions";

const val = "";

const initState = new Map({
  val,
});

export default function defaultReducer(state = initState, action) {
  switch (action.type) {
    case postsActions.GET_POSTS:
        return state;
    case postsActions.GET_POSTS_RESULT:
        return state;
    case postsActions.GET_POSTS_ERROR:
      return state;
    default:
      return state;
  }
}
